import { render } from "./IconCaretDown.vue?vue&type=template&id=4e0d33b4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCaretDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e0d33b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e0d33b4', __exports__)) {
    api.reload('4e0d33b4', __exports__)
  }
  
  module.hot.accept("./IconCaretDown.vue?vue&type=template&id=4e0d33b4", () => {
    api.rerender('4e0d33b4', render)
  })

}


export default __exports__